import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement, memo, useLayoutEffect, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '../../../../../theme/Media';
import { DATA_ATTR_TABLE_HEADROW } from '../../constants';
import { useTableContext } from '../../context';
import { buildGridColumns } from './columns';
import { HeadRowWrapper, HeadRowInner } from './styled';
export const HeadRow = memo(function HeadRow({ children, className }) {
    const { inner, registerColumns } = useTableContext();
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const columnMeta = useMemo(() => {
        const columns = Children.toArray(children)
            .filter(isValidElement)
            .map((child) => child.props);
        return buildGridColumns(columns);
    }, [children]);
    // Register columns before the mobile early-return below, so columnCount stays correct even when
    // the header itself isn't rendered on mobile (Loader and SubRow rely on it for their layout).
    useLayoutEffect(() => {
        registerColumns(columnMeta);
    }, [columnMeta, registerColumns]);
    if (isMobile && !columnMeta.hasCheckbox)
        return null;
    return (_jsx(HeadRowWrapper, { className: className, $inner: inner, role: 'presentation', [DATA_ATTR_TABLE_HEADROW]: inner ? 'inner' : 'true', children: _jsx(HeadRowInner, { role: 'row', children: children }) }));
});
